export const managementQuestions = [
  {
    category: {
      "pt-br": "DADOS BIOMÉTRICOS",
      "es-es": "DATOS BIOMÉTRICOS",
      "en-us": "BIOMETRIC DATA",
    },
    children: [
      {
        label: {
          "pt-br": "Pesagem",
          "es-es": "Pesaje",
          "en-us": "Weighing",
        },
        value: "weight",
      },
      {
        label: {
          "pt-br": "Peso do Leite (controle do leite)",
          "es-es": "Peso de la leche (control de la leche)",
          "en-us": "Milk weight (milk control)",
        },
        value: "milkWeight",
      },
    ],
  },
  {
    category: {
      "pt-br": "OUTROS",
      "es-es": "OTROS",
      "en-us": "OTHER",
    },
    children: [
      {
        label: {
          "pt-br": "Diagnóstico de Prenhez",
          "es-es": "Diagnóstico de preñez",
          "en-us": "Pregnancy diagnosis",
        },
        value: "pregnancyDiagnosis",
      },
      {
        label: {
          "pt-br": "Exame Ginecológico",
          "es-es": "Examen ginecológico",
          "en-us": "Gynecological exam",
        },
        value: "gynecologicalExam",
      },
      {
        label: {
          "pt-br": "Inseminação Artificial",
          "es-es": "Inseminación artificial",
          "en-us": "Artificial insemination",
        },
        value: "artificialInsemination",
      },
      {
        label: {
          "pt-br": "Observação de Cio",
          "es-es": "Observación de celo",
          "en-us": "Heat observation",
        },
        value: "heatObservation",
      },
      {
        label: {
          "pt-br": "Protocolo de Sincronização (IATF, TETF)",
          "es-es": "Protocolo de sincronización (IATF, TETF)",
          "en-us": "Synchronization protocol (IATF, TETF)",
        },
        value: "synchronizationProtocol",
      },
    ],
  },
  {
    category: {
      "pt-br": "MANUTENÇÃO",
      "es-es": "MANTENIMIENTO",
      "en-us": "MAINTENANCE",
    },
    children: [
      {
        label: {
          "pt-br": "Casqueamento",
          "es-es": "Recorte de pezuñas",
          "en-us": "Hoof trimming",
        },
        value: "hoofTrimming",
      },
      {
        label: {
          "pt-br": "Pedilúvio",
          "es-es": "Baño de pies",
          "en-us": "Footbath",
        },
        value: "footbath",
      },
    ],
  },
  {
    category: {
      "pt-br": "SANITÁRIO / VETERINÁRIO",
      "es-es": "SANITARIO / VETERINARIO",
      "en-us": "SANITARY / VETERINARY",
    },
    children: [
      {
        label: {
          "pt-br": "Administração de Medicamentos",
          "es-es": "Administración de medicamentos",
          "en-us": "Medication administration",
        },
        value: "medicationAdministration",
      },
      {
        label: {
          "pt-br": "Aplicação de ectoparasiticidas",
          "es-es": "Aplicación de ectoparasiticidas",
          "en-us": "Ectoparasiticide application",
        },
        value: "ectoparasiticideApplication",
      },
      {
        label: {
          "pt-br": "Aplicação de endoparasiticidas",
          "es-es": "Aplicación de endoparasiticidas",
          "en-us": "Endoparasiticide application",
        },
        value: "endoparasiticideApplication",
      },
      {
        label: {
          "pt-br": "Aplicação de vacinas",
          "es-es": "Aplicación de vacunas",
          "en-us": "Vaccine application",
        },
        value: "vaccineApplication",
      },
      {
        label: {
          "pt-br": "Exame de Brucelose",
          "es-es": "Examen de brucelosis",
          "en-us": "Brucellosis exam",
        },
        value: "brucellosisExam",
      },
      {
        label: {
          "pt-br": "Procedimento Cirúrgico",
          "es-es": "Procedimiento quirúrgico",
          "en-us": "Surgical procedure",
        },
        value: "surgicalProcedure",
      },
      {
        label: {
          "pt-br": "Tuberculinização",
          "es-es": "Tuberculización",
          "en-us": "Tuberculinization",
        },
        value: "tuberculinization",
      },
    ],
  },
];
